import { Layout, Splitter, InputRef } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import AddOnGroupList from './addongrouplist';
import AddOnGroupProperties from './addongroupproperties';
import AddOnSortableList from './addonssortablelist';
import MenuItemsWithAddOnGroup from './menuitemswithaddongroup';
import { Dayjs } from 'dayjs';
import { getMenuAddOnGroupById, getMenuAddOnGroups } from '../../services/menuaddonservice';

interface MenuAddOnGroup {
  guid: string;
  name: string;
  displayName: string;
}

export const AddOns: React.FC = () => {
  const [menuAddOnGroupsFiltered, setMenuAddOnGroupsFiltered] = useState<MenuAddOnGroup[]>([]);
  const [menuAddOnGroupsFilterText, setMenuAddOnGroupsFilterText] = useState('');
  const [menuAddOnGroups, setMenuAddOnGroups] = useState<MenuAddOnGroup[]>([]);
  const [isLoadingAddOnGroups, setIsLoadingAddOnGroups] = useState(false);
  const [selectedMaogGuid, setSelectedMaogGuid] = useState('');
  const inputRefGroupName = useRef<InputRef>(null);
  const [selectedMaogName, setSelectedMaogName] = useState('');
  const [selectedMaogDisplayName, setSelectedMaogDisplayName] = useState('');
  const [isChangeMenuAddOnGroup, setIsChangeMenuAddOnGroup] = useState('true');
  const [isShowMenuAddOnGroupProperties, setIsShowMenuAddOnGroupProperties] = useState<boolean>(false);

  useEffect(() => {
    if (isChangeMenuAddOnGroup !== '') {
      bindAddOnGroups();
      setIsChangeMenuAddOnGroup('');
    }
  }, [isChangeMenuAddOnGroup]);

  
  const bindAddOnGroups = async () => {
    setIsLoadingAddOnGroups(true);
    try {
      const data = await getMenuAddOnGroups();
      setMenuAddOnGroupsFiltered(data);
      setMenuAddOnGroups(data);
    } catch (error) {
      console.error('Error loading groups', error);
    } finally {
      setIsLoadingAddOnGroups(false);
    }
  };

  const resetAddOnProperties = () => {
    setSelectedMaogGuid('');
    setSelectedMaogName('');
    setSelectedMaogDisplayName('');
    setIsShowMenuAddOnGroupProperties(true);
    inputRefGroupName.current?.focus();
  };

  const handleFilterAddOnGroupList = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setMenuAddOnGroupsFilterText(value);
    setMenuAddOnGroupsFiltered(
      menuAddOnGroups.filter(group =>
        group.name.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  const handleClickLoadMoag = async (id: string) => {
    const maogProps = await getMenuAddOnGroupById(id);
    if (maogProps) {
      setSelectedMaogName(maogProps.name);
      setSelectedMaogDisplayName(maogProps.displayName);
      setSelectedMaogGuid(maogProps.guid);
      setIsShowMenuAddOnGroupProperties(true);
    }
  };

  const handleSetIsShowMenuAddOnGroupProperties = (flag: string) => {
    setIsShowMenuAddOnGroupProperties(flag === 'true');
  };

  return (
    <Layout
      className="full-height-layout"
      style={{ backgroundColor: '#ffffff', height: 'var(--content-height, 100vh)' }}
    >
      <Splitter
        style={{
          height: '100%',
          boxShadow: '0 0 20px rgba(0, 0, 0, 0.3)',
          overflow: 'hidden',
        }}
      //splitBarSize={8}
      >
        <Splitter.Panel defaultSize="20%" min="20%" max="70%">
          <AddOnGroupList
            isLoadingAddOnGroups={isLoadingAddOnGroups}
            menuAddOnGroups={menuAddOnGroupsFiltered}
            filterText={menuAddOnGroupsFilterText}
            onResetAddOnProperties={resetAddOnProperties}
            onClickLoadMoag={handleClickLoadMoag}
            onFilterAddOnGroupList={handleFilterAddOnGroupList}
          />
        </Splitter.Panel>
        <Splitter.Panel>
          {!isShowMenuAddOnGroupProperties && (
            <div style={{ padding: '20px' }}>
              Please select an Add-On Group or "New Add-On Group" to continue
            </div>
          )}
          {isShowMenuAddOnGroupProperties && (
            <AddOnGroupProperties
              selectedMaogGuid={selectedMaogGuid}
              inputRefGroupName={inputRefGroupName}
              selectedMaogName={selectedMaogName}
              selectedMaogDisplayName={selectedMaogDisplayName}
              setSelectedMaogGuid={setSelectedMaogGuid}
              setIsChangeMenuAddOnGroup={setIsChangeMenuAddOnGroup}
              isShowMenuAddOnGroupProperties={isShowMenuAddOnGroupProperties}
              setIsShowMenuAddOnGroupProperties={handleSetIsShowMenuAddOnGroupProperties}
            />
          )}
          {selectedMaogGuid !== '' && <AddOnSortableList selectedMaogGuid={selectedMaogGuid} />}
          <MenuItemsWithAddOnGroup selectedMaogGuid={selectedMaogGuid} />
        </Splitter.Panel>
      </Splitter>
    </Layout>
  );
};